export type RuntimeEnvironment = {
  API_PROTOCOL?: string;
  API_HOSTNAME?: string;
  API_PORT?: string;
  WEBSITE_NAME?: string;
};

export type RuntimeConfig = {
  api: {
    protocol: 'http' | 'https';
    baseUrl: string;
    port: number;
    socketProtocol: 'ws' | 'wss';
  };
  websiteName: string;
};

const requiredEnv = (environment: RuntimeEnvironment, name: keyof RuntimeEnvironment): string => {
    const value = environment[name];
    if (!value) {
        throw new Error(`Missing required environment variable: ${name}`);
    }
    return value;
};

const numberEnv = (environment: RuntimeEnvironment, name: keyof RuntimeEnvironment): number => {
    const value = Number(requiredEnv(environment, name));
    if (!Number.isFinite(value)) {
        throw new Error(`Environment variable ${name} must be a number`);
    }
    return value;
};

export const createRuntimeConfig = (environment: RuntimeEnvironment): RuntimeConfig => {
    const protocol = requiredEnv(environment, 'API_PROTOCOL');
    if (protocol !== 'http' && protocol !== 'https') {
        throw new Error('Environment variable API_PROTOCOL must be http or https');
    }

    const port = numberEnv(environment, 'API_PORT');
    if (port < 1 || port > 65535) {
        throw new Error('Environment variable API_PORT must be between 1 and 65535');
    }

    return {
        api: {
            protocol,
            baseUrl: requiredEnv(environment, 'API_HOSTNAME'),
            port,
            socketProtocol: protocol === 'https' ? 'wss' : 'ws',
        },
        websiteName: requiredEnv(environment, 'WEBSITE_NAME'),
    };
};
